import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchEvaluationTypesThunk: any = createAsyncThunk<IBindBaseEntity[]>(
  `${prefix} fetchEvaluationTypes`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getEvaluationTypes();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch evaluation types. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
